import Column from "@amzn/meridian/column";
import Alert from "@amzn/meridian/alert";
import React from "react";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import Box from "@amzn/meridian/box";

const PermissionAlertBanner = () => {
    return(
        <Column>
            <Alert type="error" size="large"><FormattedMessage id="banner.dmwPermission"/>
            </Alert>
            <Box>
                <Link target={"Link"} href="https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/DeviceManagementSCC/#HHowtoaccesstheportal">Click here</Link>
            </Box>
        </Column>
    )
}

export default PermissionAlertBanner


// WEBPACK FOOTER //
// ./src/components/commonui/PermissionAlertBanner.js